import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { AppProvider } from '@shopify/polaris'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import enTranslations from '@shopify/polaris/locales/en.json'

import AppLayout from './components/AppLayout'
import Dashboard from './pages/Dashboard'
import FormBuilderApp from './pages/FormBuilderApp'
import Settings from './pages/Settings'
import Plans from './pages/Plans'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 30, retry: 1 },
  },
})

// App Bridge v4 uses /exitiframe?redirectUri=... to break out of the iframe
function ExitIframe() {
  const [params] = useSearchParams()
  const redirectUri = params.get('redirectUri')
  if (redirectUri) {
    window.top ? (window.top.location.href = redirectUri) : (window.location.href = redirectUri)
  }
  return null
}

function App() {
  return (
    <AppProvider i18n={enTranslations}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            {/* App Bridge v4 exit-iframe route */}
            <Route path="/exitiframe" element={<ExitIframe />} />

            <Route path="/" element={<AppLayout />}>
              <Route index element={<Navigate to="/forms" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="plans" element={<Plans />} />
              <Route path="settings" element={<Settings />} />
              {/* Form builder manages its own views internally */}
              <Route path="forms/*" element={<FormBuilderApp />} />
            </Route>

            {/* Catch-all — redirect unknown paths to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </AppProvider>
  )
}

export default App
